import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows"]
  static values = { roles: Array }

  addRow() {
    const roles = this.rolesValue
    let options = ""
    roles.forEach(([label, value]) => {
      options += `<option value="${value}">${label}</option>`
    })

    const row = document.createElement("tr")
    row.innerHTML = `
      <td><input class="form-control form-control-sm" type="text" name="organization[sso_role_mapping_groups][]" placeholder="e.g. Admins"></td>
      <td><select class="form-control form-select form-select-sm" name="organization[sso_role_mapping_roles][]">${options}</select></td>
      <td><button class="btn btn-sm btn-soft-danger" type="button" data-action="click->sso-role-mapping#removeRow"><i class="fa-solid fa-trash"></i></button></td>
    `
    this.rowsTarget.appendChild(row)
  }

  removeRow(event) {
    const row = event.currentTarget.closest("tr")
    if (this.rowsTarget.querySelectorAll("tr").length > 1) {
      row.remove()
    } else {
      // Clear values instead of removing last row
      row.querySelector("input").value = ""
      row.querySelector("select").selectedIndex = 0
    }
  }
}
